module.exports = {
  customer: 'hampshire',
  environment: 'production',
  isBetterCare: true,
  yourMoney: true,
  jobsVolunteering: false,
  googleAnalyticsId: 'G-FGQRDZ8WE5',
  robots: false,
  chatWidget: false,
  entitledToBaseUrl: 'https://hampshirebettercare.entitledto.co.uk',
  entitledToReassessUrl: 'https://hampshirebettercare.entitledto.co.uk/reassessbetteroff',
  requirePostcode: false,

  app: {
    home: 'https://hampshire.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-hampshire.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-hampshire.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account.hampshire.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showAssessmentMutators: false,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
